<template>
    <div id="message-area-header">
        <SuperMenu
            v-model="superMenu"
            @updateSuperMenuState="superMenu = $event"
            @usedComamnd="usedSlashCommand"
            @send="$emit('send', $event)"
            v-if="superMenu.enabled"
            :contact="contact"
        />
        <div class="conversation-types">
            <div class="conversation-types-item" :class="{ selected: mode === 'chat' }" @click="selectMode('chat')">
                <div class="material-icons">language</div>
                Chat
            </div>
            <div
                class="conversation-types-item"
                :class="{ selected: mode === 'email' }"
                @click="$feature.beforeClickEmailFn(selectMailMode)"
            >
                <div class="material-icons">mail</div>
                Email
            </div>
            <div
                class="conversation-types-item"
                :class="{ selected: mode === 'sms' }"
                @click="$feature.beforeClickSmsFn(selectSMSMode)"
            >
                <div class="material-icons">sms</div>
                SMS
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { log2 } from "../../../../../utils/log2";
import SuperMenu from "./super-menu/SuperMenu.vue";
import _ from "lodash";
import TemplateMessages from "./super-menu/TemplateMessages.vue";

const log = log2("MessageAreaHeader");
export default {
    name: "MessageAreaHeader",
    components: { TemplateMessages, SuperMenu },
    props: {
        conversation: {
            type: Object,
            default: () => ({}),
        },
        mode: {
            type: String,
            default: "web",
        },
        superMenuState: {
            type: Object,
            default: () => ({}),
        },
        contact: {
            type: Object,
        },
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
            user: (state) => state.auth.user,
        }),
    },
    data() {
        return {
            superMenu: this.superMenuState,
        };
    },
    methods: {
        selectMode(mode) {
            this.$emit("modeChanged", mode);
        },
        selectMailMode() {
            this.selectMode("email");
        },
        selectSMSMode() {
            this.selectMode("sms");
        },
        usedSlashCommand(command) {
            this.$emit("usedSlashCommand", command);
        },
    },
    watch: {
        superMenuState: {
            handler(val) {
                const iSChanged = !_.isEqual(this.superMenu, val);
                if (iSChanged) {
                    this.superMenu = val;
                }
            },
            immediate: true,
            deep: true,
        },
        superMenu: {
            handler(val) {
                const iSChanged = !_.isEqual(this.superMenuState, val);
                if (iSChanged) {
                    this.$emit("updateSuperMenuState", val);
                }
            },
            immediate: true,
            deep: true,
        },
    },
};
</script>
<style lang="scss" scoped>
#message-area-header {
    position: relative;

    .conversation-types {
        border-bottom: 1px solid var(--border-neutral-default);
        width: 100%;
        background: var(--color-bg-neutral-default);
        padding: 2px;
        display: flex;
        align-items: center;
        gap: 2px;

        &-item {
            padding: 5px 15px;
            border-radius: 4px;
            cursor: pointer;
            display: flex;
            align-items: center;
            gap: 4px;

            .material-icons {
                font-size: 18px;
            }

            &.selected {
                background: #22272d;
                color: white;

                .material-icons {
                    color: white;
                }
            }
        }
    }
}
</style>
